import { RETURN_URL_QUERY_PARAM } from '@assetron/common/constants/constant';
import { useEffect } from 'react';

const useExternalRedirect = (
  isUserAuthenticated: boolean,
  redirectUrl: string,
  returnUrl: string,
) => {
  useEffect(() => {
    if (!isUserAuthenticated) {
      const url = new URL(redirectUrl);
      if (returnUrl) {
        url.searchParams.set(RETURN_URL_QUERY_PARAM, returnUrl);
      }
      window.sessionStorage.clear();
      window.location.href = url.toString();
    }
  }, [isUserAuthenticated, redirectUrl, returnUrl]);
};

export default useExternalRedirect;
